module.exports = __webpack_public_path__ + "static/media/cahliHero.f42f4740.jpg";